export default {
    infoData: {
        companyName: '',
        siteName: '',
        ledgerName: '',
        operationType: '',
        accidentNo: '',
        feeSupplierName: '',
        profitTypeName: '',
        initialTotalAmt: '',
        chargeoffTime: '',
        currencyCode: '',
        isReplaceSettlement: '',
        remark: '',
        isAccident: '',
        totalAmt: ''
    },
    tableDataItems: [
        {
            prop: 'feeHeaderName',
            label: '费用名称',
            type: 'normal'
        },
        {
            prop: 'currencyCode',
            label: '币种',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'custName',
            label: '运作客户',
            type: 'normal'
        },
        {
            prop: 'orderBusinessTypeName',
            label: '业务大类',
            type: 'normal'
        },
        {
            prop: 'businessDate',
            label: '业务日期',
            type: 'normal'
        },
        {
            prop: 'fineTypeName',
            label: '罚扣款子类',
            type: 'normal'
        },
        {
            prop: 'amt',
            label: '罚扣款金额',
            type: 'normal'
        },
        {
            prop: 'fineCause',
            label: '罚扣款原因',
            type: 'normal'
        },
        {
            prop: 'ettaNo',
            label: '运输单号',
            type: 'normal'
        }
    ]

};
